import { Controller } from "@hotwired/stimulus"

// A button that shows or hides one panel and reports the state through
// aria-expanded; the panel starts hidden in the markup.
export default class extends Controller {
  static targets = ["panel"]

  toggle(event) {
    const open = this.panelTarget.hidden
    this.panelTarget.hidden = !open
    event.currentTarget.setAttribute("aria-expanded", open)
  }
}
